import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';
import { SearchboxMatch } from '../searchbox/SearchboxMatch';

type ResultInfoProps = {
    result: Result;
};

export function ResultInfo(props: ResultInfoProps) {
    const { result } = props;

    if (!result.info1) {
        return null;
    }

    return (
        <span className="block text-s overflow-hidden overflow-ellipsis whitespace-nowrap">
            <SearchboxMatch value={result.info1} query={result.originalQuery} />
        </span>
    );
}
